<template>
    <nav aria-label="breadcrumbs">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <NuxtLink class="breadcrumb-link" :href="homeUrl">
                    {{ homeText }}
                </NuxtLink>
            </li>
            <li v-for="(item, index) in items" :key="index" 
                :class="['breadcrumb-item', item.children && item.children.length > 0 ? 'dropdown' : '']"
                :aria-current="index === items.length - 1 ? 'page' : undefined">
                
                <template v-if="item.children && item.children.length > 0">
                    <a class="breadcrumb-link dropdown-toggle" 
                       data-bs-toggle="dropdown" 
                       href="javascript:;" 
                       role="button" 
                       aria-haspopup="true" 
                       aria-expanded="false">
                        {{ item.name }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu--breadcrumb">
                        <li v-for="(child, childIndex) in item.children" :key="childIndex" class="dropdown-item">
                            <NuxtLink class="dropdown-link" 
                                :to="localePath(`${child.url}`)" 
                                :target="child.target || '_self'">
                                {{ child.name || child.name || 'Unnamed Item' }}
                            </NuxtLink>
                        </li>
                    </ul>
                </template>
                
                <template v-else-if="index === items.length - 1">
                    <span class="breadcrumb-link active">{{ item.name }}</span>
                </template>
                
                <NuxtLink v-else class="breadcrumb-link" :to="localePath(`${item.url}`)">
                    {{ item.name }}
                </NuxtLink>
            </li>
        </ol>
    </nav>
</template>

<script setup>

const localePath = useLocalePath();

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  homeUrl: String,
  homeText: String,
})

// เพิ่ม debug เพื่อตรวจสอบข้อมูล
console.log('Breadcrumbs item:', props.items)
</script>

<style lang="scss">
@import "@/assets/scss/app";

@each $lang in $languages {
    html[lang='#{$lang}'] {
        .breadcrumb{
            .breadcrumb-item{
                .breadcrumb-link{
                    @include font-size('h4', $lang);
                }
            }
        }
       .dropdown-menu{
            &.dropdown-menu--breadcrumb{
                .dropdown-link{
                    @include font-size('h4', $lang);
                    line-height: 1.2;
                }
            }
        }
    }
}
.breadcrumb {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin-bottom: 1rem;
    list-style: none;
    position: relative;

        @include media-breakpoint-down(lg) {
            display: none;
        }
    
    .breadcrumb-item {
        display: flex;
        padding-left: 0;
        
        &:not(:first-child)::before {
            display: inline-block;
            padding-right: 0.75rem;
            padding-left: 0.75rem;
            color: $white;
            content: "|";
        }

        .breadcrumb-link {
            color: $white;
            text-decoration: none;
            background-color: transparent;
            
            @include hover-focus-active {
                color: $green-2;
            }

        }
        
        &.dropdown {
            
            .dropdown-menu {
                &.dropdown-menu--breadcrumb{
                    position: absolute;
                    top: 100%;
                    left: 0;
                    z-index: 1000;
                    display: none;
                    min-width: 13rem;
                    padding: 0.65rem 0;
                    margin: 0.75rem 0.45rem;
                    background: rgba($lightgreen-1, 0.90);
                    backdrop-filter: blur(2.5px);
                    border-radius: 12px;
                    border: 0;
                    max-height: 600px;
                    overflow: auto;
                    
                    &.show {
                        display: block;
                    }

                    .dropdown-item {
                        padding: 0.25rem 0.75rem;
                        white-space: wrap;
                        
                        @include hover-focus-active {
                            text-decoration: none;
                            background-color:transparent;
                        }

                        .dropdown-link {
                            color: $black;
                            text-decoration: none;
                            display: block;
                            width: 100%;
                            
                            @include hover-focus-active {
                                color: $green-2;
                            }
                        }
                    }
                }
            }
            
            .dropdown-toggle {
                padding-right: 1.40rem;

                &::after{
                      color: $green-2;
                      @include font-fontawesome('\f078');
                      position: absolute;
                      border: 0;
                      font-size: 12px;
                      font-weight: 500;
                      top: 0;
                      bottom: 0;
                      display: inline-flex;
                      align-items: center;
                      right: 0;
                      margin: 0;
                 }
             } 
           
        }
    }
    
   
    

}
</style>